import React from 'react'
import { FormRenderProps } from 'react-final-form'
import constSubmittedType from '../../../../../../constants/submittedType'
import useWebService from '../../../../../../services/web/useWebService'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import checkPermission from '../../../../../../utilities/checkPermission'
import useAuthenStore from '../../../../../../stores/authen/authenStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'
import { ResultDocumentTopicLut } from '../../../../../../services/lookup/types/responseLookupServiceTypes'
import * as REQServiceType from '../../../../../../services/web/types/requestWebServiceTypes'
import * as Constants from '../../../../../../constants/constants'
import * as Utils from '../../../../../../utilities/date'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useTranslate from '../../../../../../i18n/useTranslate'
import { RoutePath } from '../../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import useLoading from '../../../../../../control/loading/useLoading'
import useFolderAndTab from '../../../useFolderAndTab'

import { uploadFileObjType } from '../../verifyDocument/verifyDocumentType'
import { CloseProjectByAdminType } from './closeProjectByAdmin'
import { checkAllAdditionalDocTopicsHavePdf, withFileTokenInfo } from '../../../../../../utilities/additionalDoc'
type OptType = {
    label: string
    value: string
}
type UploadFileObjType = {
    uploadFileObj: {
        documentTopicID: number

        fileList: {
            documentTopicID: number
            fileID: string
            fileToken: string
            filename: string
            path: string
        }[]

        subTopicPageList?: {
            page: string
            documentTopicID: number
            subtopicID: number
        }[]
    }
}
type MyFileDataType = {
    documentTopicID?: number
    fileTokenInfo: Array<{
        fileID: any
        replaceFileID: number
        fileToken: string
        fileExtension?: string
    }>
    subtopic?: {
        subtopicID: number
        page: number
    }[]
}
const useCloseProjectByAdmin = (props: CloseProjectByAdminType) => {
    const { projectData, onSaveComplete } = props

    const history = useHistory()
    const tabAndFolderHook = useFolderAndTab()
    const loadingHook = useLoading()
    const callLookup = useLookupService()
    const callWebService = useWebService()
    const translate = useTranslate()
    const checkPermissionHook = checkPermission()
    const authenStore = useAuthenStore()
    const { profile } = authenStore

    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()
    const appFolderAndTabAction = useAppFolderAndTabAction()

    const [isCompletely, setIsCompletely] = React.useState<boolean>(true)
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()

    const documentTopicRef = React.useRef<ResultDocumentTopicLut[]>()
    const [initialValues, setInitialValues] = React.useState<any>({})
    const reviewerLutRef = React.useRef<OptType[]>()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const formRef = React.useRef<FormRenderProps>()

    React.useEffect(() => {
        if (projectData) {
            setIsCompletely(projectData?.verifyDocument ?? true)
            getReviewer(projectData.irb)
            createInitialData()
        }

        if (projectData?.irb && projectData?.submitTypeInfo?.value) {
            getDocumentTopicLut(projectData?.irb, projectData?.submitTypeInfo.value)
        }
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null])

    React.useEffect(() => {
        createInitialUploadFile()
    }, [
        manageProjectStore.documentTopic,
        JSON.stringify(manageProjectStore.projectData?.documentInfo),
        JSON.stringify(manageProjectStore.projectData?.latestDocument),
    ])

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const filterTopicUpload = (documentTopic: ResultDocumentTopicLut[]) => {
        let docTopic: ResultDocumentTopicLut[] = []
        const researcherTypeID = manageProjectStore?.projectData?.researcherTypeInfo.value

        if (documentTopic) {
            let isDocTopic = documentTopic
            if (researcherTypeID === 1) {
                Constants.topicForLecturer.forEach((element) => {
                    docTopic = documentTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                })
            } else {
                Constants.topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, no: index + 1 }
                })
                manageProjectAction.setDocumentTopic(docTopic)
            }
        }
    }

    const getDocumentTopicLut = async (irb: number, submitType: number) => {
        if (irb) {
            const res = await callLookup.callDocumentTopicLut(irb, submitType)
            if (res.status === 1) {
                manageProjectAction.setDocumentTopic(res.result)
                filterTopicUpload(res.result)
                documentTopicRef.current = res.result
            } else {
                manageProjectAction.setDocumentTopic([])
                documentTopicRef.current = []
            }
        }
    }

    const createInitialUploadFile = () => {
        const documentInfo = projectData?.documentInfo
        // ------------------------------------------------------------- //
        let uploadFileInit = manageProjectStore.documentTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                    isDisplay: itm.isDisplay,
                    isRequired: itm.isRequired,
                },
            }
        }) as Array<UploadFileObjType>

        uploadFileInit?.forEach((itm: uploadFileObjType) => {
            documentInfo?.forEach((docInfo: any) => {
                if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                    //@ts-ignore
                    itm.uploadFileObj.fileList = docInfo.fileInfo
                    //@ts-ignore
                    itm.uploadFileObj.subTopicPageList = docInfo.subtopic
                }
            })
        })

        //Filter การซ่อนแสดงหัวข้อเอกสาร ถ้าฝั่งสำนักงานให้ซ่อนหัวข้อเอกสาร แต่ว่าหัวข้อนั้นมีไฟล์อยู่ให้ทำการแสดงหัวข้อนั้นออกมา
        if (uploadFileInit?.length > 0) {
            uploadFileInit = uploadFileInit.filter((itm: any) => {
                return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
            })
        }
        setInitialUploadFile(uploadFileInit)
    }

    const getReviewer = async (irb: number) => {
        if (irb) {
            const res = await callLookup.callReviewerLut(irb)
            const formatedData = res.result.map((itm) => {
                return {
                    label: itm.name_th,
                    value: `${itm.id}`,
                }
            })
            reviewerLutRef.current = formatedData
        }
    }

    const handleChangeDocCompletely = (val: string) => {
        const isCompletely = val === '1' ? true : false
        setIsCompletely(isCompletely)
    }

    const createInitialData = () => {
        const defaultCompletely = projectData?.verifyDocument ?? '1'
        const initialData = {
            isCompletelyDoc: defaultCompletely === '1' ? defaultCompletely : projectData?.verifyDocument ? '1' : '2',
            resubmitDocDate: projectData?.resubmitDocDate ? projectData?.resubmitDocDate : null,
            //@ts-ignore
            reviewer: projectData?.reviewerUserID
                ? {
                      label: `${projectData?.reviewerName_th}`,
                      value: `${projectData?.reviewerUserID}`,
                  }
                : null,
            remark: projectData?.verifyDocumentRemark,
            remarkWithFormat: projectData?.verifyDocumentWithFormat,
            documentAdditionalInfo: projectData?.documentAdditionalInfo,
        }

        setInitialValues(initialData)
    }

    const checkUseUploadEdit = () => {
        let isUseUploadEdit = false

        switch (projectData?.submitTypeInfo?.value) {
            case constSubmittedType.nonconformance:
                isUseUploadEdit = true
                break
            default:
                isUseUploadEdit = false
                break
        }

        return isUseUploadEdit
    }
    const handleDirtyChange = (props: { dirty: boolean }) => {
        let isDirty: boolean = false
        if (!isViewMode) {
            isDirty = props.dirty
        }
        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: isDirty ? callbackDirtyProcess : undefined,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const getSaveServiceParameter = (isDraft: boolean) => {
        const parameterForSave = {
            projectID: projectData?.projectID || null,
            submittedID: projectData?.submittedID || null,
            irb: projectData?.irb || null,
            userID: profile.userId as number,
            projectName_th: projectData?.projectName_th || null,
            projectName_en: projectData?.projectName_en || null,
            projectSubmitTypeID: projectData?.submitTypeInfo.value || null,

            facultyID: projectData?.facultyInfo.value || null,
            requestPhase: projectData?.requestPhase || null,
            isTools: projectData?.isTools,
            researcherTypeID: projectData?.researcherTypeInfo.value || null,
            titleNameID: projectData?.titleNameInfo.value || null,
            titleNameOther_th: projectData?.titleNameOther_th || null,
            titleNameOther_en: projectData?.titleNameOther_en || null,
            academicPositionID: projectData?.academicPositionInfo?.value || null,
            academicPositionOther_th: projectData?.academicPositionOther_th || null,
            academicPositionOther_en: projectData?.academicPositionOther_en || null,
            educationLevelID: projectData?.educationLevelInfo ? projectData?.educationLevelInfo.value : null,
            researcherName_th: projectData?.researcherName_th || null,
            researcherName_en: projectData?.researcherName_en || null,
            email: projectData?.email || null,
            homePhone: projectData?.homePhone || null,
            mobilePhone: projectData?.mobilePhone || null,
            fax: projectData?.fax || null,
            isDraft: isDraft,
            isLanguage_th: projectData?.isLanguageTH,
            isLanguage_en: projectData?.isLanguageEN,
            isRequestCertificatePaper: projectData?.isRequestCertificatePager ? true : false,
            isDr: projectData?.isDr,
            documentAdditionalInfo: projectData?.documentAdditionalInfo,
        } as REQServiceType.ReportedAdverseEventsRequestType

        return parameterForSave
    }
    const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
        const isDraft: boolean = true
        const param = getSaveServiceParameter(isDraft)

        processSaveData(param, {
            idx: tabIndex,
            selectedInfo: newTabSelected,
        })
    }

    const processSaveData = async (
        param: REQServiceType.CloseProjectByAdminNew,
        changeTabOpt?: { idx: number; selectedInfo: any },
    ) => {
        try {
            dialogRef.current?.closeDialog()
            loadingHook.loadingOpen()
            const response = await callWebService.closeProjectByAdminNew(param)

            if (changeTabOpt) {
                if (changeTabOpt.idx !== null && changeTabOpt.selectedInfo !== null) {
                    tabAndFolderHook.setTab(changeTabOpt.idx, changeTabOpt.selectedInfo)
                }
            } else {
                if (onSaveComplete) onSaveComplete(response.status, param.isDraft as boolean)
            }
        } catch (ex) {
            console.log('useVerifyDocument.ts => processSaveData : ', ex)
        } finally {
            loadingHook.loadingClose()
        }
    }

    const handleSubmitForm = async (value: any) => {
        const isDraft: boolean = value?.submitType !== 'save'
        const param = getSaveServiceParameter(isDraft)
        const paramSave = {
            ...param,
            documentInfo: getDocumentInfo(value),
            documentAdditionalInfo: withFileTokenInfo(value.documentAdditionalInfo),
        }

        switch (value.submitType) {
            case 'save':
                handleSave(paramSave)
                break

            case 'draft':
                handleSaveDraft(paramSave)
                break
            default:
                break
        }
    }
    const handleSaveDraft = (param: any) => {
        processSaveData(param)
    }

    const handleSave = async (param: any) => {
        const isRequirePDF = checkRequirePDF(param.documentInfo)
        const allAdditionalDocTopicsHavePdf = checkAllAdditionalDocTopicsHavePdf(param.documentAdditionalInfo)

        if (isRequirePDF || !allAdditionalDocTopicsHavePdf) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.UPLOAD_PDF_AT_LEAST_1_FILE'),
                type: 'alert-message',
            })
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => handleClickConfirmSave(param),
            })
        }
        // }
        dialogRef.current?.openDialog()
    }
    const checkRequirePDF = (documentInfo: MyFileDataType[]) => {
        let isRequirePDF = false
        for (let i = 0; i < documentInfo?.length; i++) {
            if (!isRequirePDF) {
                for (let j = 0; j < documentInfo[i]?.fileTokenInfo.length; j++) {
                    if (documentInfo[i]?.fileTokenInfo[j].fileExtension === 'pdf') {
                        isRequirePDF = false
                        break
                    } else {
                        isRequirePDF = true
                    }
                }
            }
        }
        return isRequirePDF
    }

    const handleClickConfirmSave = (param: any) => {
        processSaveData(param)
    }
    const getDocumentInfo = (val: any) => {
        let fileDataList = val.uploadFile.filter((itm: any) => itm.uploadFileObj.fileList.length > 0)
        let myFileData: Array<REQServiceType.DocumentInfo> = []

        fileDataList.forEach((uploadObj: UploadFileObjType) => {
            const subTopicLst = uploadObj?.uploadFileObj.subTopicPageList?.map((subtopic) => {
                return {
                    subtopicID: subtopic.subtopicID,
                    page: subtopic.page,
                }
            })

            const fileTokenInfo: Array<{
                replaceFileID: number
                fileToken: string
                fileExtension?: string
                fileID: any
            }> =
                uploadObj.uploadFileObj.fileList?.map((file) => {
                    return {
                        //@ts-ignore
                        replaceFileID: file?.replaceFileID ? file.replaceFileID : null,
                        fileToken: file.fileToken,
                        fileExtension: file.filename.split('.').pop(),
                        fileID: file?.fileID ? file.fileID : null,
                    }
                }) ?? []

            myFileData.push({
                documentTopicID: uploadObj?.uploadFileObj?.documentTopicID,
                fileTokenInfo: fileTokenInfo,
                subtopic: subTopicLst && subTopicLst.length > 0 ? subTopicLst : [],
            })
        })

        return myFileData
    }
    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    return {
        formRef,
        configDialog,
        onRefDialog,
        isCompletely,
        initialUploadFile: initialUploadFile,
        isViewMode,
        initialValues,
        isShowUpdateDate,
        onSubmitForm: handleSubmitForm,
        onChangeDocCompletely: handleChangeDocCompletely,
        checkUseUploadEdit: checkUseUploadEdit,
        onDirtyChange: handleDirtyChange,
        onClickBackToSearch: handleClickBackToSearch,
    }
}
export default useCloseProjectByAdmin
